import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  TextField,
  CircularProgress,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { useStore } from "@store/store";
import closeIcon from "@assets/images/close.svg";
import { AddEditPreshiftPopupStyle } from "./style";

function PreshiftPopup(props) {
  const classes = AddEditPreshiftPopupStyle();
  const [scroll] = useState("body");
  const [state] = useStore();
  const originalPreshiftQuestion = props?.questionData?.originalQuestionText || "";

  return (
    <Dialog
      open={props.open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={classes.customModal}
      scroll={scroll}
    >
      <div className="close-modal">
        <img 
          src={closeIcon} 
          alt="Close" 
          onClick={props.handleClose} 
          style={state.driver?.addingPreshiftQuestion || 
            state.driver?.editingPreshiftQuestion ? 
            { pointerEvents: "none", opacity: 0.5, cursor: "default" } 
            : {}
          }
        />
      </div>
      <form
        noValidate
        autoComplete="off"
        className={classes.customForm}
        onSubmit={props.formik.handleSubmit}
      >
        {props.error && <Alert severity="error">{props.error}</Alert>}
        <DialogTitle id="alert-dialog-title">
          {props.isEdit ? "Edit" : "Add"} Preshift Question
        </DialogTitle>
        {state.driver.gettingDriverById === true ? (
          <CircularProgress
            color="inherit"
            size={80}
            className="cirularProgess"
          />
        ) : (
          <DialogContent>
            <div className="form-row">
              <div className="form-gourp">
                <FormControl variant="outlined" className={classes.formControl}>
                  <label className="label-text" htmlFor="questionText">
                    Question Text <span className="error-text">*</span>
                  </label>
                  <TextField
                    id="questionText"
                    placeholder="Enter question text"
                    variant="outlined"
                    type="text"
                    onChange={props.formik.handleChange}
                    value={props.formik.values.questionText}
                    disabled={state?.driver?.addingPreshiftQuestion || state?.driver?.editingPreshiftQuestion}
                    error={
                      props.formik.touched.questionText &&
                      Boolean(props.formik.errors.questionText)
                    }
                    helperText={
                      props.formik.touched.questionText && props.formik.errors.questionText
                    }
                  />
                </FormControl>
              </div>
            </div>
          </DialogContent>
        )}

        <DialogActions className="bottom-button-block">
          <Button
            className="primary-btn gray-border-btn"
            color="inherit"
            disableElevation
            underlinenone="true"
            onClick={props.handleClose}
            style={state?.driver?.addingPreshiftQuestion || 
              state?.driver?.editingPreshiftQuestion ? 
              { pointerEvents: "none", opacity: 0.5 } 
              : {}
            }
            disabled={state?.driver?.addingPreshiftQuestion || state?.driver?.editingPreshiftQuestion}
          >
            CANCEL
          </Button>
          <Button
            className="orange-btn primary-btn"
            color="inherit"
            disableElevation
            underlinenone="true"
            type="submit"
            disabled={state?.driver?.addingPreshiftQuestion || state?.driver?.editingPreshiftQuestion || (originalPreshiftQuestion === props?.formik?.values?.questionText?.replace(/\s+/g, " ").trim())}
          >
            {state?.driver?.addingPreshiftQuestion || state?.driver?.editingPreshiftQuestion ? (
              <CircularProgress color="inherit" size={35}/>
            ) : "SAVE"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

export default PreshiftPopup;
